<template>
    <section>
        <el-form inline>
            <el-form-item>
                <el-select clearable v-model="filters.form_id" @change="toGetList" placeholder="选择表单">
                    <el-option
                        v-for="(item,key) in all_forms"
                        :key="key"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select clearable v-model="filters.status" @change="toGetList" placeholder="状态">
                    <el-option v-for="(key,val) in statusObj" :key="key" :label="key" :value="val"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="toGetList">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="table1" :data="lists">
            <el-table-column label="表单名字" prop="title"></el-table-column>
            <el-table-column label="填写时间" prop="add_time" :formatter="formatTime" align="center"></el-table-column>
            <el-table-column label="申请人" prop="applicant.name" align="center"></el-table-column>
            <el-table-column label="状态" prop="status" :formatter="formatStatus" align="center"></el-table-column>
            <el-table-column align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="getSee(scope.row)">查看详情</el-button>

                    <el-button
                        type="text"
                        @click="revoke(scope.row)"
                        v-if="scope.row.status=='COMMIT'||scope.row.status=='PENDDING'"
                    >撤回</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange"
            :current-page="filters.page"
            :page-sizes="[10,20, 30, 50, 70,100]"
            :page-size="filters.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRow"
        ></el-pagination>

        <!-- 预览 -->
        <form-detail
            :visible.sync="is_show"
            :apply_id="apply_id"
            @close="closeDetail"
            type="disable"
            size="50%"
        />
    </section>
</template>

<script>
import { oa_approvals } from "@/api/oa";
import { cms_form } from "@/api/cms";
import formatter from "@/mixins/formatter";
import formDetail from "@/components/form_custom/preview/detail";
export default {
    mixins: [formatter],
    props: {},
    data() {
        return {
            filters: {
                page: 1,
                size: 10,
                catalog_id: null,
                status: null,
                title: null,
                form_id: null,
                my_apply: true,
            },
            totalRow: 0,
            lists: [],
            loading: false,

            statusObj: {
                // COMMIT: "已发起",
                REVOKE: "已撤回",
                PENDDING: "待审核",
                APPROVAL: "审核通过",
                UNPASSED: "驳回",
                REJECT: "已拒绝",
            },

            apply_id: null,
            is_show: false,
            all_forms:[],
        };
    },

    components: { formDetail },
    computed: {},

    methods: {
        closeDetail(val){
            this.is_show=false
            if(val==1){
                this.getList()
            }
        },
        getSee(data) {
            this.apply_id = data.id;
            this.is_show = true;
        },

        revoke(data) {
            this.$confirm("确定要撤回?", "提示", {
                confirmButtonText: "撤回",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                oa_approvals.revoke({ id: data.id || data._id }).then((res) => {
                    if (res.data) {
                        this.$notify({
                            title: "提示",
                            type: "success",
                            duration: 2000,
                            message: "撤回成功!",
                        });
                        this.getList();
                    }
                });
            });
        },
        formatTime(data) {
            return this.timeForLimitTime(data.add_time);
        },
        formatStatus(data) {
            return this.statusObj[data.status];
        },
        toGetList() {
            this.filters.page = 1;
            this.filters.status = this.filters.status || null;
            this.filters.form_id=this.filters.form_id||null
            this.getList();
        },
        getList() {
            let param = Object.assign(this.filters);
            this.loading = true;
            oa_approvals.paginate(param).then((res) => {
                this.loading = false;
                if (res.data) {
                    this.totalRow = res.data.totalRow;
                    this.lists = res.data.list;
                }
            });
        },
        handlePageChange(val) {
            this.filters.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.filters.size = val;
            this.getList();
        },
    },

    mounted() {
        cms_form
            .find({ type: 1, name: null, catalog_id: null, status: "ON" })
            .then((res) => {
                if (res.data && res.data.length > 0) {
                    this.all_forms = res.data.map((r) => {
                        return {
                            id: r.id || r._id,
                            name: r.name,
                        };
                    });
                }
            });
        this.toGetList();
    },
};
</script>

<style scoped lang="scss">
.el-form-item {
    margin-bottom: 10px;
}
.el-button--text {
    color: #007aff;
}
</style>



// WEBPACK FOOTER //
// src/views/approvals/my/history.vue